import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

/**
 * Espone l'evento di Ionic per collegare il pull-to-refresh alla ricarica della
 * pagina senza duplicare la configurazione del componente tra le viste.
 */
@Directive({
  selector: 'ion-refresher[appPullToRefresh]',
  standalone: false
})
export class PullToRefreshDirective {
  @Output() refresh = new EventEmitter<CustomEvent>();

  @HostBinding('attr.slot') readonly slot = 'fixed';

  @HostListener('ionRefresh', ['$event'])
  onRefresh(event: CustomEvent): void {
    this.refresh.emit(event);
  }
}
